import { inventoryPaths } from "api/apiPaths";
import client from "api/client";
import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { InventoryRequestModel } from "./model/InventoryRequestModel";
import { InventoryResponseModel } from "./model/InventoryResponseModel";
import { InventoryCreateActionRequestModel } from "./model/actions/InventoryCreateActionRequestModel";
import { InventoryUpdateActionRequestModel } from "./model/actions/InventoryUpdateActionRequestModel";
import { InventoryDetailResponseModel } from "./model/detail/InventoryDetailResponseModel";
import { ExportInventoryRequestModel } from "./model/exportInventory/ExportInventoryRequestModel";

export interface IInventoriesRespository {
  getList(
    params: InventoryRequestModel
  ): Promise<BaseApiResponseModel<InventoryResponseModel[]>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<InventoryDetailResponseModel>>;
  createInventory(
    body: InventoryCreateActionRequestModel
  ): Promise<BaseApiResponseModel<InventoryResponseModel>>;
  updateInventory(
    body: InventoryUpdateActionRequestModel
  ): Promise<BaseApiResponseModel<InventoryResponseModel>>;
  deleteInventory(params: {
    code: string;
  }): Promise<BaseApiResponseModel<InventoryResponseModel>>;
  exportInventory(
    params: ExportInventoryRequestModel
  ): Promise<BaseApiResponseModel<unknown>>;
}

class InventoriesImpl implements IInventoriesRespository {
  async getList(
    params: InventoryRequestModel
  ): Promise<BaseApiResponseModel<InventoryResponseModel[]>> {
    return await client?.get(inventoryPaths?.LIST, params);
  }
  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<InventoryDetailResponseModel>> {
    return await client?.get(inventoryPaths?.DETAIL, params);
  }
  async updateInventory(
    body: InventoryUpdateActionRequestModel
  ): Promise<BaseApiResponseModel<InventoryResponseModel>> {
    return await client?.put(inventoryPaths?.UPDATE, body);
  }
  async createInventory(
    body: InventoryCreateActionRequestModel
  ): Promise<BaseApiResponseModel<InventoryResponseModel>> {
    return await client?.post(inventoryPaths?.CREATE, body);
  }
  async deleteInventory(params: {
    code: string;
  }): Promise<BaseApiResponseModel<InventoryResponseModel>> {
    return await client?.delete(inventoryPaths?.DELETE, params);
  }

  async exportInventory(
    params: ExportInventoryRequestModel
  ): Promise<BaseApiResponseModel<any>> {
    return await client?.get(
      inventoryPaths?.EXPORT,
      params,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      "arraybuffer"
    );
  }
}

export const defaultInventoriesRepository = new InventoriesImpl();
